import BsButton from 'react-bootstrap/Button';
import PropTypes from 'prop-types';

import useSideRailContext from '../../../stores/profile/use-side-rail-context';
import { augmentClassName } from '../../../utils/GlobalCssProxy';
import useProfileAppContext from '../../../stores/profile/use-profile-app-context';

import styles from './button-disclosures.module.scss';
const className = augmentClassName(styles);

// First draft - Left for backwards compatibility
const ButtonDisclosures = ({ color, module }) => {
  const { disclosures = {} } = useSideRailContext() || {};

  return (
    <BsButton
      {...className('p-0', 'font-size-14', 'd-print-none', color)}
      variant="link--reverse-underline"
      size="sm"
      onClick={() => disclosures.show(module)}
    >
      More Information
    </BsButton>
  );
};

ButtonDisclosures.defaultProps = {
  color: 'text-black'
};

ButtonDisclosures.propTypes = {
  color: PropTypes.string,
  module: PropTypes.string
};

// Second draft - Support for different styles of buttons
const configuredComponent = ({ children, classes, size, variant }) => {

  const Component = props => {
    const { disclosures = {} } = useSideRailContext() || {};

    return (
      <BsButton
        {...className(...classes, ...props.classes, 'd-print-none')}
        onClick={() => disclosures.show(props.module)}
        size={props.size || size}
        variant={props.variant || variant}
      >
        {props.children || children}
      </BsButton>
    );
  };

  Component.defaultProps = {
    classes: [],
    module: ''
  };

  Component.propTypes = {
    children: PropTypes.node,
    classes: PropTypes.arrayOf(PropTypes.string),
    module: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'lg']),
    variant: PropTypes.string
  };

  return Component;
};

ButtonDisclosures.Button = configuredComponent({
  children: 'Disclosures',
  classes: ['btn--rounded'],
  size: 'sm',
  variant: ''
});

export default ButtonDisclosures;
